import { createSearchEngine } from '../engine';

const QUERY_PARAM = 'q';

export const googleSearch = createSearchEngine({
  safeParam: {
    key: 'safe',
    value: 'active',
  },
  isSearch: (url: URL): boolean => {
    return (
      /^(www\.)?google\.[a-zA-Z0-9]+$/.test(url.hostname) &&
      /^\/search/.test(url.pathname) &&
      url.searchParams.has(QUERY_PARAM)
    );
  },
});
